/* tslint:disable */
/* eslint-disable */
/**
 * Client Signup API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { SignupStep } from './';
import {
    SignupStepFromJSON,
    SignupStepFromJSONTyped,
    SignupStepToJSON,
} from './';

/**
 * 
 * @export
 * @interface StepPhoneNumber
 */
export interface StepPhoneNumber extends SignupStep {
}

/**
 * Check if a given object implements the StepPhoneNumber interface.
 */
export function instanceOfStepPhoneNumber(value: object): value is StepPhoneNumber {
    return true;
}

export function StepPhoneNumberFromJSON(json: any): StepPhoneNumber {
    return StepPhoneNumberFromJSONTyped(json, false);
}

export function StepPhoneNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): StepPhoneNumber {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepFromJSONTyped(json, ignoreDiscriminator),
    };
}

export function StepPhoneNumberToJSON(value?: StepPhoneNumber | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...SignupStepToJSON(value, true),
    };
}

